<template>
  <v-container fluid>
    <v-layout wrap>
      <v-flex
        xs12
        sm12
        md3
        xl3>
        <formAdminMonthlyCrossChargeFilter :view="'linked-account'"/>
      </v-flex>
      <v-flex
        md9
        xl9/>
      <v-flex
        xs12
        sm12
        md12>
        <material-card
        >
          <v-layout
            wrap>
            <v-flex
              xs12
              sm3
              md3>
              <v-text-field
                v-model="search"
                label="Search"
                single-line
                hide-details
                append-icon="search"
              />
            </v-flex>
          </v-layout>
          <v-data-table
            :headers="linkedAccountHeaders"
            :items="allFinanceLinkedAccounts"
            :search ="search"
            :pagination.sync="pagination"
          >
            <template
              slot="headerCell"
              slot-scope="{ header }">
              <span
                class="subheading font-weight-light text-success text-md-left text--darken-3"
                v-text="header.text"
              />
            </template>
            <template
              v-slot:items="props">
              <td>
                <router-link
                  :to="'/admin/financial-administration/monthly-cross-charge/linked-account/'+ props.item.LinkedAccountId">
                  {{ props.item.LinkedAccountId }}
                </router-link>
              </td>
              <td>{{ props.item.LinkedAccountName }}</td>
            </template>
          </v-data-table>
        </material-card>

      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data: () => ({
    loader: null,
    search: '',
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      totalItems: 0,
      sortBy: 'LinkedAccountId'
    }
  }),
  computed: {
    ...mapState('admin/financialAdministration', ['linkedAccounts', 'linkedAccountHeaders', 'allAccounts']),
    allFinanceLinkedAccounts () {
      let displayLinkedAccounts = this.allAccounts.reduce(function (linkedAccountIds, account) {
        if (!linkedAccountIds.hasOwnProperty(account.LinkedAccountId)) {
          linkedAccountIds[account.LinkedAccountId] = {
            LinkedAccountId: account.LinkedAccountId,
            LinkedAccountName: account.LinkedAccountName
          }
        }
        linkedAccountIds[account.LinkedAccountId]
        return linkedAccountIds
      }, {})

      // lets convert it to array
      let listLinkedAccountNames = []
      for (let [name, value] of Object.entries(displayLinkedAccounts)) {
        listLinkedAccountNames.push(value)
      }
      return listLinkedAccountNames
    }
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
</style>
